// https://vuex.vuejs.org/en/modules.html
interface Dict { [key: string]: any }

// import.meta.glob replaces webpack's require.context; eager so store module
// registration stays synchronous. Keys keep the './name/part.ts' shape.
const requireModule: Dict = import.meta.glob('./**/*.ts', { eager: true })
const modules: Dict = {}

Object.keys(requireModule).forEach((fileName) => {
  if (fileName === './index.ts') { return; }

  // Replace ./ and .ts
  const path = fileName.replace(/(\.\/|\.ts)/g, '')
  const [moduleName, imported]: string[] = path.split('/')

  if (!modules[moduleName]) {
    modules[moduleName] = {
      namespaced: true,
    }
  }

  modules[moduleName][imported] = requireModule[fileName].default
})

export default modules

// This makes sure modules in sub directories are accessed through
// the appropriate namespace.
// EG usage in a component script, to access a prop of the app module:
// computed: {
//   ...mapState('utils', ['image', 'color']),
//   color(): any {
//     return this.$store.state.utils.color
//   }
// }
